import {SET_FILTER} from 'src/pages/localChannelLineup/store/actions/setFilter';

export const filter = (state = '', {type, value} = {}) => {
  switch (type) {
    case SET_FILTER:
      return value.filter;
    default:
      return state;
  }
};
